import React from "react";
import "./GetInTouch.css";
import getintouch from "../../assets/imgs/getintouch.jpg";
import ContactForm from "../ContactForm/ContactForm";

function GetInTouch() {

  return (
    <div className="gtinTch">
      <div className="maxW">
        <div className="gethMn">
          <div className="gethLft">
            <img src={getintouch} alt="getintouch" />
          </div>
          <div className="gethRyt">
            <div className="formWrp">
              <h2>Get in Touch</h2>
              <p>Submit the form, and our team will reach out to you.</p>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetInTouch;
